import React from 'react';

const SingleStatCard = ({ title, value, subtitle, icon, color = '#3253DC', tooltip }) => {
  return (
    <div className="single-stat-card" title={tooltip || undefined}>
      <div className="single-stat-header">
        {icon && <div className="single-stat-icon" style={{ color }}>{icon}</div>}
        <h3 className="single-stat-title">{title}</h3>
      </div>
      <div className="single-stat-content">
        <div className="single-stat-value" style={{ color }}>
          {typeof value === 'number' ? value.toLocaleString() : value || '-'}
        </div>
        {subtitle && <div className="single-stat-subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

export default SingleStatCard;
